// routes/patientRoutes.tsx
import HomePage from "../pages/patients/HomePage";
import Register from "../pages/patients/Register";
import LoginPage from "../pages/LoginPage";
import ForgotPasswordPage from "../pages/patients/ForgotPasswordPage";
import ResetPasswordForm from "../pages/patients/ResetPasswordPage";
import PatientDashboard from "../pages/dashboards/PatientDashboard"; // ✅ Nouveau import
import AppointmentsPage from "../pages/patients/Appointments";
import RequireAuth from "../components/RequireAuth";
import CreateAppointmentForm from "../pages/patients/AppointmentsForm";

export const patientRoutes = (onLoginSuccess: (token: string) => void) => [
  { path: "/", element: <HomePage /> },
  { path: "/register", element: <Register /> },
  { path: "/login", element: <LoginPage onLoginSuccess={onLoginSuccess} /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/resetpassword", element: <ResetPasswordForm /> },

  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <PatientDashboard /> {/* ✅ Utilisation du wrapper */}
      </RequireAuth>
    ),
    children: [
      { path: "appointment", element: <AppointmentsPage /> },
      { path: "appointments/new", element: <CreateAppointmentForm /> },
      // ✅ Ajoutez les routes manquantes selon votre configuration du menu :
      // { path: "history", element: <HistoryPage /> },
      // { path: "prescriptions", element: <PrescriptionsPage /> },
      // { path: "account", element: <AccountPage /> },
    ],
  },
];
